import Image1 from "@assets/KPMG/Financing/1.png";
import Image2 from "@assets/KPMG/Financing/2.png";
import Image3 from "@assets/KPMG/Financing/3.png";
import Image4 from "@assets/KPMG/Financing/4.png";

export const PooledFinancingData = [
  {
    id: "1",
    title: "EV Procurement in ASEAN",
    agency: "Temasek",
    location: "Philippines",
    rating: "4.0",
    image: Image1,
    amount: "$50,000,000",
  },
  {
    id: "2",
    title: "Solar Power Generation in ASEAN",
    agency: "GIC",
    location: "Malaysia",
    rating: "4.0",
    image: Image2,
    amount: "$30,000,000",
  },
  {
    id: "3",
    title: "Smart City Development in ASEAN",
    agency: "Invesco",
    location: "Philippines",
    rating: "4.0",
    image: Image3,
    amount: "$120,000,000",
  },
  {
    id: "4",
    title: "Railway Development in ASEAN",
    agency: "Kapor Capital",
    location: "Malaysia",
    rating: "4.0",
    image: Image4,
    amount: "$100,000,000",
  },
  {
    id: "5",
    title: "EV Procurement in ASEAN",
    agency: "Temasek",
    location: "Philippines",
    rating: "4.0",
    image: Image1,
    amount: "$50,000,000",
  },
  {
    id: "6",
    title: "Solar Power Generation in ASEAN",
    agency: "GIC",
    location: "Malaysia",
    rating: "4.0",
    image: Image2,
    amount: "$30,000,000",
  },
  {
    id: "7",
    title: "Smart City Development in ASEAN",
    agency: "Invesco",
    location: "Philippines",
    rating: "4.0",
    image: Image3,
    amount: "$120,000,000",
  },
  {
    id: "8",
    title: "Railway Development in ASEAN",
    agency: "Kapor Capital",
    location: "Malaysia",
    rating: "4.0",
    image: Image4,
    amount: "$100,000,000",
  },
];
